module.exports = __webpack_public_path__ + "static/media/mail.180a5b74.svg";